import { getSingleText } from '../../../common/utils';

export function getEngagementTextByFlavorAndType(textKey, flavor, engagementType) {
  const textsPrefix = 'app.pages.global.mobile.engagementDesign';
  return getSingleText(`${textsPrefix}.${flavor}.${engagementType}.${textKey}`);
}